import Intercom, { update, onShow, shutdown, boot } from "@intercom/messenger-js-sdk";
import { GetIntercomUserHashPlatformEnum } from "@tableyeti/merchant-service";
import { watch } from "vue";
import { useYetipayApi } from "@/composables/useYetipayApi";
import { useAuthenticationStore } from "@/store/authentication";
import { useMerchantsStore } from "@/store/merchants";

export default {
  install() {
    const initialiseUnverifiedUser = () => {
      Intercom({
        app_id: import.meta.env.VITE_INTERCOM_APP_ID,
      });
    };

    const loginVerifiedUser = async () => {
      const { api } = useYetipayApi();
      const { data } = await api.getIntercomUserHash(GetIntercomUserHashPlatformEnum.Web);
      boot({
        app_id: import.meta.env.VITE_INTERCOM_APP_ID,
        email: authenticationStore.user.email,
        user_id: authenticationStore.user.id,
        user_hash: data.userHash,
      });
    };

    initialiseUnverifiedUser();

    const authenticationStore = useAuthenticationStore();
    const merchants = useMerchantsStore();

    watch(
      () => merchants.currentMerchant?.merchantId,
      async () => {
        if (merchants.currentMerchant?.merchantId) {
          loginVerifiedUser();
        } else {
          shutdown();
          initialiseUnverifiedUser();
        }
      },
    );

    onShow(() => {
      const merchantsStore = useMerchantsStore();
      const authenticationStore = useAuthenticationStore();
      if (!authenticationStore.user.isAuthenticated) {
        return;
      }

      update({
        legalEntityNAme: merchantsStore.currentMerchant?.legalEntityName,
        internalId: merchantsStore.currentMerchant?.merchantId,
        stripeCustomerId: merchantsStore.currentMerchant?.stripeCustomerId,
      });
    });
  },
};
